import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { Switch } from '@mui/material';
import { set_ui_settings } from 'console/redux/settings-actions';
import { DeviceStateIndicator } from 'console/shared/components/indicators/device-state';
import { UniversalMenu } from 'console/shared/components/menu';
import { Delete } from '@mui/icons-material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { DeviceIconState } from 'console/device/icon/types';
import { zontnext_devices_all_state_filters } from 'console/device/icon/transform';
import { useAction } from 'shared/hooks/redux/hooks';
export const FiltersMenu = memo(function FiltersMenu(props) {
    const { anchor, onMenuClose, selected_filters } = props;
    const setUiSettings = useAction(set_ui_settings);
    const makeOnFilterClick = useCallback((state) => () => {
        const are_filter_selected = selected_filters.find((selected_filter) => selected_filter === state);
        const turn_on_filter = [...selected_filters, state];
        const turn_off_filter = selected_filters.filter((selected_filter) => selected_filter !== state);
        setUiSettings({
            devices_state_filters: are_filter_selected
                ? turn_off_filter
                : turn_on_filter,
        });
    }, [selected_filters]);
    const onClearFiltersClick = useCallback((event) => {
        event.stopPropagation();
        setUiSettings({
            devices_state_filters: [],
        });
    }, []);
    const menu_items = useMemo(() => [
        {
            onClick: onClearFiltersClick,
            label: 'Убрать все фильтры',
            icon: _jsx(Delete, { color: "action" }),
            show: selected_filters.length > 0 && !isMediumUI(),
            divider: { content: true },
        },
        ...zontnext_devices_all_state_filters.map((filter) => {
            const { text, state } = filter;
            return {
                onClick: makeOnFilterClick(state),
                label: text,
                icon: _jsx(DeviceStateIndicator, { state: state }),
                additional_view: (_jsx(Switch, { size: "small", color: state === DeviceIconState.online
                        ? 'success'
                        : state === DeviceIconState.alarm ||
                            state === DeviceIconState.offline
                            ? 'error'
                            : state === DeviceIconState.guard_zone_alarm ||
                                state === DeviceIconState.sensor_alarm
                                ? 'warning'
                                : 'primary', checked: selected_filters.includes(state) })),
            };
        }),
        {
            onClick: onClearFiltersClick,
            label: 'Убрать все фильтры',
            icon: _jsx(Delete, { color: "action" }),
            show: selected_filters.length > 0 && isMediumUI(),
            divider: { position: 'top', content: true },
        },
    ], [selected_filters, makeOnFilterClick, onClearFiltersClick]);
    return (_jsx(UniversalMenu, { menu_items: menu_items, anchor: anchor, onClose: onMenuClose, opened: !!anchor }));
});
